import { dataHooks } from '@wix/data-hooks';

import { LayoutSize } from '../../../../components-shared/LayoutSizeProvider/types';

export const menuSectionDataHooks = dataHooks<{
  root: {};
  title: {};
  description: {};
  dishGrid: {};
}>('menu-section');

export const SECTION_IMAGE_WIDTH: Record<LayoutSize, number> = {
  [LayoutSize.XS]: 640,
  [LayoutSize.S]: 1000,
  [LayoutSize.M]: 2000,
  [LayoutSize.L]: 2400,
};

export const SECTION_IMAGE_HEIGHT = 1200;
